//import './Resources.css';
import Nav from '../components/Nav';

const Resources = () => {
  return(
    <Nav/>
  );
};
export default Resources;
